import { useContext } from "react";

import { Form, useActionData } from "react-router-dom";
import HeaderClasses from '../components/AppHeader/AppHeader.module.css';

import MenuContext from '../store/MenuContext';
import RegisterClasses from '../components/Register/Register.module.css';

import { forgotPassword } from '../utils/api';

function ForgotPassword() {
    const actionData=useActionData();

	const menuTheme = useContext(MenuContext);

    return (
		<div className={RegisterClasses.testInfo}>
    		  <div className={RegisterClasses.testInfoContent}>
				<Form method='post'>
					<div className={RegisterClasses['form-control']}>
						<h1>Forgot Password</h1>
						<p>Please enter your username and we'll send you an email with a link to reset your password.</p>
						{actionData?.errors && <div className={HeaderClasses.error}>{actionData.errors}</div>}
						<label>Username:</label> 
						<input name="username" type="text"/><br/>
						<nav className={HeaderClasses.headerNav}>
							<div className={RegisterClasses.buttonArea}>  
				            	<button className={HeaderClasses.navItem}>Reset password</button>
							</div>
						</nav>
						{actionData?.email && <p >
						  Please check your email for a reset password link.
						</p>}
					</div>
				</Form>
			</div>
		</div>
  );
}

export default ForgotPassword;

export async function action({ request, params }) {
  const data = await request.formData();

  const messages={};
  const resUsername = {
	username: data.get('username'),
  };
  const resData = await forgotPassword(resUsername);
  console.log(resData);
  
  if(resData.ok) {
	  messages.email=1;
	return messages;
  }else{
	  console.log(resData);
	  messages.errors="Could not find record.";
	  return messages;
  };

}